import { message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import Utils from "../../../../../utils/Utils";
import WebUtils from "../../../../../utils/WebUtils";
import { getResumeDropDown } from "../../../../../api/b2b-candidate";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";

function ResumeListModal({ resumeListFlag, setResumeListFlag, setLoading }) {
  const userDetail = Utils.getUserDetail();
  const navigate = useNavigate();

  const [resumeDropdownList, setResumeDropdownList] = useState([]);
  const [selectedList, setSelectedList] = useState(null);

  const getResumeDropdownApi = () => {
    const url = `${getResumeDropDown}?organizationId=${
      userDetail?.organizationId || null
    }&userIdentifier=${userDetail?.userIdentifier}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setResumeDropdownList(result?.data?.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const resumeOptions = Array.from(
    new Map([
      ...(resumeDropdownList || [])?.map((item) => [
        item.resumeIdentifier,
        {
          label: (
            <div>
              <p className="font-medium mb-0">
                {item.resumeFileName}{" "}
                <span className="text-[.75rem] text-gray-500">
                  ({item.resumeIdentifier})
                </span>
              </p>

              <p className="text-[.75rem] text-gray-500 mb-0">
                Uploaded on{" "}
                {new Date(item.uploadedDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
              <p className="text-[.75rem] text-gray-500 mb-0">
                {item.resumeOptimizerState}
              </p>
            </div>
          ),

          value: item.resumeIdentifier,
          title: item.resumeFileName,
        },
      ]),
    ]).values(),
  );

  useEffect(() => {
    getResumeDropdownApi();
  }, []);

  return (
    <Modal
      open={resumeListFlag}
      onCancel={() => setResumeListFlag(false)}
      centered
      footer={null}
      title={
        <div className="flex items-center gap-[.5rem] text-[1rem]">
          <FileText size={19} />
          <span>Resume List</span>
        </div>
      }
    >
      <div className="mt-5">
        <p>Select resume </p>
        <Select
          //   allowClear
          className="w-full mt-1"
          size="large"
          placeholder="Select resume"
          value={selectedList}
          onChange={setSelectedList}
          options={resumeOptions}
          optionLabelProp="title"
        />
      </div>
      <div className="mt-5">
        <p className="text-sm text-gray-600">
          <span className="font-medium">Note:</span> If you don't see your
          resume here, please{" "}
          <span
            onClick={() => navigate("/cv-optimizer?tab=allResumes")}
            className="text-blue-600 underline cursor-pointer hover:text-blue-700"
          >
            go to the Resume Upload page
          </span>{" "}
          and upload your resume.
        </p>
      </div>
      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setResumeListFlag(false)}
        >
          Cancel
        </button>

        <button
          //   disabled={selectedBatchGuides?.length < 1}
          onClick={() => {
            if (!selectedList) {
              message.error("Please select a resume");
              return;
            }
            navigate(`/editResume?resumeIdentifier=${selectedList}`);
          }}
          className={` btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Polish your resume
        </button>
      </div>
    </Modal>
  );
}

export default ResumeListModal;
